<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';
import {
  apiReferenceDate,
  displayReferenceDate,
  maskReferenceDate,
} from './postSaleDate';
import { salesPartyDocumentText } from './salesPartyDocumentI18n';

const props = defineProps({
  item: { type: Object, required: true },
  i18nScope: { type: String, default: 'SALES_PARTIES' },
});

const emit = defineEmits(['save', 'update']);
const { t } = useI18n();
const text = salesPartyDocumentText(t, props.i18nScope);

const calculateExpiry = (issuedOn, validityDays) => {
  const days = Number(validityDays);
  const normalizedIssuedOn = apiReferenceDate(issuedOn);
  if (!normalizedIssuedOn || !days) return '';
  const date = new Date(`${normalizedIssuedOn}T00:00:00Z`);
  if (Number.isNaN(date.getTime())) return '';
  date.setUTCDate(date.getUTCDate() + days);
  return displayReferenceDate(date.toISOString().slice(0, 10));
};

const update = (field, event) => {
  const value =
    field === 'issued_on'
      ? maskReferenceDate(event.target.value)
      : event.target.value.replace(/\D/g, '');
  const item = { ...props.item, [field]: value };
  item.expires_on = calculateExpiry(item.issued_on, item.validity_days);
  emit('update', item);
};
</script>

<template>
  <div
    class="grid gap-2 pb-[15px] min-[701px]:grid-cols-[minmax(0,1fr)_100px_150px_140px]"
    data-test="sales-party-document-validity-fields"
  >
    <LaisField :label="text.document">
      <input
        :value="item.name"
        disabled
        class="h-10 w-full rounded-lais-sm border border-lais-border bg-white px-3 text-sm text-lais-text-muted"
      />
    </LaisField>
    <LaisField :label="text.validityDays">
      <input
        :value="item.validity_days"
        type="number"
        min="1"
        data-test="validity-days"
        class="h-10 w-full rounded-lais-sm border border-lais-border bg-white px-3 text-sm text-lais-text"
        @input="update('validity_days', $event)"
        @blur="emit('save')"
      />
    </LaisField>
    <LaisField :label="text.issuedOn">
      <input
        :value="displayReferenceDate(item.issued_on)"
        type="text"
        inputmode="numeric"
        maxlength="10"
        data-test="issued-on"
        class="h-10 w-full rounded-lais-sm border border-lais-border bg-white px-3 text-sm text-lais-text"
        @input="update('issued_on', $event)"
        @blur="emit('save')"
      />
    </LaisField>
    <LaisField :label="text.expiresOn">
      <input
        :value="displayReferenceDate(item.expires_on)"
        disabled
        type="text"
        data-test="expires-on"
        class="h-10 w-full rounded-lais-sm border border-lais-border bg-white px-3 text-sm text-lais-text-muted"
      />
    </LaisField>
  </div>
</template>
